const SUBJECT = "Ihre Zugangsdaten zur Abelia Planung";

export function createAccountMailtoUrl({ email, name, loginUrl, initialPassword, reset = false }) {
  const body = [
    `Guten Tag ${name},`,
    "",
    reset ? "Das Passwort für Ihr Konto in der Abelia Planung wurde administrativ zurückgesetzt." : "Ihr Konto für die Abelia Planung wurde erstellt.",
    "",
    `Login-Adresse: ${loginUrl}`,
    `Vorübergehendes Passwort: ${initialPassword}`,
    "",
    "Bitte wählen Sie bei Ihrem ersten Login ein neues, persönliches Passwort.",
    "",
    "Freundliche Grüsse",
  ].join("\r\n");

  return `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(SUBJECT)}&body=${encodeURIComponent(body)}`;
}
